/* ATD • Back to Top */
(() => {
  const SHOW_AT = 400; // px scrolled before showing
  const root = document.getElementById('atd-back-to-top');

  const ready = (fn) =>
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn, { once: true })
      : fn();

  function throttle(fn, ms) {
    let t = 0;
    return () => {
      const now = Date.now();
      if (now - t > ms) { t = now; fn(); }
    };
  }

  function toggle() {
    if (!root) return;
    const show = (window.scrollY || window.pageYOffset) > SHOW_AT;
    root.toggleAttribute('hidden', !show);
    root.setAttribute('aria-hidden', String(!show));
    root.classList.toggle('is-visible', show);
  }

  function scrollTopSmooth() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  }

  ready(() => {
    if (!root) return;

    const btn = root.querySelector('[data-btt]');
    if (btn) {
      btn.addEventListener('click', scrollTopSmooth);
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollTopSmooth(); }
      });
    }

    // Initial + listeners
    toggle();
    window.addEventListener('scroll', throttle(toggle, 80), { passive: true });
    window.addEventListener('resize', throttle(toggle, 120));
  });
})();
